var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('TheModeA'),_c('div',{staticClass:"modelb"},[_c('TheModeB')],1),_c('TheModeC'),_c('TheModeD')],1)}
var staticRenderFns = []

export { render, staticRenderFns }